import { getLocalStorageItem } from "./storage";

export const debugLog = (message: string, ...args: any[]) => {
  if ((window as any)?.logDebug || getLocalStorageItem("logDebug") === "true") {
    console.log(message, ...args);
  }
};

export const performanceLog = (message: string, ...args: any[]) => {
  if (
    (window as any)?.logPerformance ||
    getLocalStorageItem("logPerformance") === "true"
  ) {
    console.log(message, ...args);
  }
};
